import { AddDateBtn, AddDateWrapper, Btn } from "../Paragraph/paragraph.styles";
import { ReactComponent as PlusSvg } from "@assets/icons/plus.svg";
import Dropdown from "components/atoms/Dropdown/dropdown";
import { DDButton, DDContent } from "../../display/Chapter/сhapter.styles";
import DateSelector from "components/atoms/DateSelector/dateSelector";
import { CloseOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { ChapterDatesWrapper } from "../editor.styles";
import { useTranslation } from "react-i18next";
import { useChapterEditorDataContext } from "contexts/ChapterEditorContext";

const ChapterDates = () => {
  const { t } = useTranslation();
  const { draftChapter, updateDraftChapter } = useChapterEditorDataContext();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hasFromDate, setHasFromDate] = useState<boolean>(!!draftChapter.date_from_day || !!draftChapter.date_from_month || !!draftChapter.date_from_year);
  const [hasToDate, setHasToDate] = useState<boolean>(!!draftChapter.date_to_day || !!draftChapter.date_to_month || !!draftChapter.date_to_year);

  const updateFromDate = (d: number | null, m: number | null, y: number | null) => {
    updateDraftChapter({
      date_from_day: d,
      date_from_month: m,
      date_from_year: y,
    });
  };

  const updateToDate = (d: number | null, m: number | null, y: number | null) => {
    updateDraftChapter({
      date_to_day: d,
      date_to_month: m,
      date_to_year: y,
    });
  };

  const clearDates = () => {
    updateFromDate(null, null, null);
    updateToDate(null, null, null);
    setHasFromDate(false);
    setHasToDate(false);
  }

  const addDates = (period?: boolean) => {
    setHasFromDate(true);
    if (period) setHasToDate(true);
    setDropdownOpen(false);
  }

  const hasNoDates = !hasFromDate && !hasToDate;

  return (
    <ChapterDatesWrapper>
      {hasNoDates && (
        <AddDateWrapper>
          <AddDateBtn onClick={() => setDropdownOpen(p => !p)}>
            {t('wall.addDate')} <PlusSvg />
          </AddDateBtn>
          <Dropdown position="left" isOpen={dropdownOpen} onClose={() => setDropdownOpen(false)}>
            <DDContent>
              <DDButton onClick={() => addDates()}>{t('wall.fixedDate')}</DDButton>
              <DDButton onClick={() => addDates(true)}>
                {t('wall.period')}
              </DDButton>
            </DDContent>
          </Dropdown>
        </AddDateWrapper>
      )}
      {hasFromDate && (
        <DateSelector
          initialDay={draftChapter.date_from_day}
          initialMonth={draftChapter.date_from_month}
          initialYear={draftChapter.date_from_year}
          onChange={updateFromDate}
        />
      )}
      {hasToDate && <div>{" -> "}</div>}
      {hasToDate && (
        <DateSelector
          initialDay={draftChapter.date_to_day}
          initialMonth={draftChapter.date_to_month}
          initialYear={draftChapter.date_to_year}
          onChange={updateToDate}
        />
      )}
      {hasFromDate && (
        <Btn onClick={clearDates}>
          <CloseOutlined />
        </Btn>
      )}
    </ChapterDatesWrapper>
  );
};

export default ChapterDates;
